export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 0_02.00e0f979.jpg";